module.exports = __webpack_public_path__ + "static/media/lr.039251e3.svg";